import { render, staticRenderFns } from "./userbodyhistorycalculate.vue?vue&type=template&id=4d7a1c98&"
import script from "./userbodyhistorycalculate.vue?vue&type=script&lang=js&"
export * from "./userbodyhistorycalculate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports